module.exports = __webpack_public_path__ + "static/media/29BDOS18.f984c793.jpg";